// extracted by mini-css-extract-plugin
module.exports = {"reciept__actions":"InvoicesRecieptActions_reciept__actions__SXoOT","btn__cancel":"InvoicesRecieptActions_btn__cancel__tpANU"};